var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCloseBlack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31055 1.70636L5.10748 4.90942L8.31055 8.11249L7.50305 8.91998L4.29999 5.71692L1.09692 8.91998L0.289429 8.11249L3.49249 4.90942L0.289429 1.70636L1.09692 0.898865L4.29999 4.10193L7.50305 0.898865L8.31055 1.70636Z",
    fill: "#212121"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-black.8fb1cd4f.svg";
export { ForwardRef as ReactComponent };